import { Tab, Tabs } from '@mui/material'
import { ITabOptions } from 'components/table/table-tabs'

interface HeaderModuleTabsDashProps {
  onChange: (tab: number) => void
  current: number
  options: ITabOptions[]
  moduleName: string
  isSeller: boolean
  disableOptions?: number[]
}

const HeaderModuleDashTabs = ({
  onChange,
  current,
  options,
  moduleName,
  isSeller,
  disableOptions = [],
}: HeaderModuleTabsDashProps) => (
  <Tabs
    value={current}
    onChange={(_event, newValue) => onChange(newValue)}
    aria-label={`${moduleName} tabs`}
  >
    {options.map(({ handleClick, title, size }, index) => (
      <Tab
        label={size && size != 0 ? `${title} (${size})` : title}
        key={index}
        id={`${moduleName}-tab-${index}`}
        aria-controls={`${moduleName}-tabpanel-${index}`}
        onClick={handleClick}
        disabled={(isSeller && disableOptions.includes(index)) || (!isSeller && index !== 0)}
      />
    ))}
  </Tabs>
)

export default HeaderModuleDashTabs
